import { CLIENT_CURRENT } from 'constants';
import * as privateActions from './private';
import * as business from './business';

export const current = payload => ({ type: CLIENT_CURRENT, payload });
export {
	privateActions,
	business,
};
